import logger from '../utils/logger';
import type { ParsedText } from '../types';

export async function parseTxt(file: File): Promise<ParsedText> {
  const startTime = performance.now();
  const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);

  logger.info('TXT parse started', {
    fileName: file.name,
    fileSizeMB,
    fileSize: file.size
  });

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e: ProgressEvent<FileReader>) => {
      if (e.target?.result && typeof e.target.result === 'string') {
        const parsedText = { text: e.target.result, title: file.name.replace(/\.[^.]+$/, '') };
        const durationMs = Math.round(performance.now() - startTime);

        logger.info('TXT parse completed', {
          fileName: file.name,
          textLength: parsedText.text.length,
          durationMs
        });

        resolve(parsedText);
      } else {
        const durationMs = Math.round(performance.now() - startTime);
        const error = new Error('Failed to read text file');

        logger.error('TXT parse failed - no text content', error, {
          fileName: file.name,
          fileSizeMB,
          durationMs
        });

        reject(error);
      }
    };
    reader.onerror = () => {
      const durationMs = Math.round(performance.now() - startTime);
      const error = new Error('Failed to read text file');

      logger.error('TXT parse failed - FileReader error', error, {
        fileName: file.name,
        fileSizeMB,
        durationMs
      });

      reject(error);
    };
    reader.readAsText(file);
  });
}
